import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { HtmlUtils } from '@core/helpers/HtmlUtils';

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-total-balance',
    templateUrl: './total-balance-card.component.html',
    styleUrls: ['./total-balance-card.component.scss']
})
export class TotalBalanceCardComponent extends BaseComponent<BaseState> {

    @Input() Currency: string;
    @Input() Title: string;
    @Input() Amount: number;
    @Input() Icon: string;
    @Input() Color: string;
    @Input() IsHideCharge: boolean = false;
    @Input() AmountTemplate: TemplateRef<any>;
    @Input() AdditionalTemplate: TemplateRef<any>;
    @Input() ViewStyle: 'normal' | 'line-to-side' = 'normal';
    @Input() Tooltip: string;
    private TooltipUIID: string;

    private _onClickObserved: boolean;
    @Output() OnClick: EventEmitter<void> = new EventEmitter;

    constructor(A: ServiceBagService) {
        super(A, 'TotalBalanceCardComponent', BaseState);
        this.TooltipUIID = 'tbc-tooltip' + (Math.round(Math.random() * 1000000)).toString();
    }

    protected override OnInitComponent(): void {
        this._onClickObserved = this.OnClick.observed;
    }

    HasClickEvent(event) {
        return this._onClickObserved;
    }

    OnCardClick(event) {
        this.OnClick && this.OnClick.emit(event);
    }

    GetBoxShadowStyle() {
        if (!this.Color) return '';
        
        const rgb = HtmlUtils.HexToRgbColorString(this.Color);
        if (!rgb) return '';

        return `0 4px 14px rgba(${rgb}, 0.4)`;
    }

    GetIconBackgroundColor() {
        if (!this.Color) return '';

        const rgb = HtmlUtils.HexToRgbColorString(this.Color);
        if (!rgb) return '';

        return `rgba(${rgb}, 0.12)`;
    }
}
